import { useState } from "react";
import { hotList } from "@/mocks/content";

const filterTabs = ["全部", "魔改解说", "恶搞剧情", "神吐槽", "爆笑名场面", "弹幕梗"];

export default function HotSection() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? hotList : hotList.filter((h) => h.tag === active);

  return (
    <section id="hot" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-fire-fill"></i>
              每期高能
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              本周爆款合集
            </h2>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {filterTabs.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setActive(t)}
                className={
                  active === t
                    ? "whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-sm text-background-50"
                    : "whitespace-nowrap rounded-full bg-background-200/70 px-4 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
                }
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {list.map((item, i) => (
            <article
              key={item.title}
              className="group overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-shadow hover:border-primary-300"
            >
              <div className="relative aspect-[16/9] w-full overflow-hidden bg-primary-200">
                <img
                  src={item.image}
                  alt={`${item.title} 封面`}
                  title={`${item.title} 火影恶搞`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">
                  {item.badge}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-flex rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">
                  {item.tag}
                </span>
                <h3 className="mt-2 line-clamp-2 text-sm font-medium text-foreground-950 md:text-base">
                  {item.title}
                </h3>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-thumb-up-line"></i>
                    {item.likes}
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1 text-primary-600">
                    <i className="ri-heart-fill text-accent-500"></i>
                    {item.likesPercent}% 喜欢
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}